import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AuthService } from '../../core/auth.service';
import { GigService } from '../../core/gig.service';
import { JobService } from '../../core/job.service';
import { VolService } from '../../core/vol.service';
import { AdService } from '../../core/ad.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'header-desktop',
    styleUrls: ['./header-desktop.scss'],
    templateUrl: './header-desktop.html',
    standalone: true,
    imports: [CommonModule]
})
export class HeaderDesktopComponent {
  webURL: string = environment.webURL;
  appURL: string = environment.appURL;
  bucketURL: string = environment.firebase.bucketURL;
  gigsintown: any;
  jobsintown: any;
  volsintown: any;
  adsintown: any;

  constructor(
    public auth: AuthService,
    private gs: GigService,
    private js: JobService,
    private vs: VolService,
    private as: AdService,
  ) { }

  loadGigs() {
    this.gigsintown = this.gs.gigs();
  }

  loadJobs() {
    this.jobsintown = this.js.jobs();
  }

  loadVols() {
    this.volsintown = this.vs.vols();
  }

  loadAds() {
    this.adsintown  = this.as.ads();
  }
}
